__turbopack_context__.v({
  "Image": "GallerySection-module-scss-module__qy6oda__Image",
  "ImagesGrid": "GallerySection-module-scss-module__qy6oda__ImagesGrid",
  "OpenGallery": "GallerySection-module-scss-module__qy6oda__OpenGallery",
  "Slide": "GallerySection-module-scss-module__qy6oda__Slide",
  "Swiper": "GallerySection-module-scss-module__qy6oda__Swiper",
});
